// Institute of Design and Innovation (email idi@unm.edu). //

import { ReportAppointment, ReportResult } from '@/models/reportResult'
import { AxiosResponse } from 'axios'
import httpClient from './httpClient'

export default class ReportingService {
  /**
   * Genereate report
   * @param spec report specifics
   */
  public static generateReport (spec: object): Promise<AxiosResponse<ReportResult>> {
    return httpClient.post('reporting', spec)
  }

  /**
   * Download report
   * @param spec report specifics
   */
  public static downloadReport (spec: object): Promise<AxiosResponse<string>> {
    return httpClient.post('reporting/download', spec)
  }
}
